import D2C_ServiceApp from './App'

class D2C_ServicePHP extends D2C_ServiceApp {
  static objectType = 'serviceType'
  static active = false
  static order = 10
  static typeName = 'php'
  static typeTitle = 'PHP-FPM'
  static color = '#7777cc'
  static methods = {
    ...D2C_ServiceApp.methods,
    balance: false,
    scale: true,
  }
  static fields = {
    ...D2C_ServiceApp.fields,
    configs: {
      ...D2C_ServiceApp.fields.configs,
      default: [
        {name: 'php.ini', text: require('raw-loader!@/assets/configs/php-php.ini').default, custom: false},
        {name: 'php-fpm.conf', text: require('raw-loader!@/assets/configs/php-php-fpm.conf').default, custom: false},
      ],
    },
    hosts: {
      ...D2C_ServiceApp.fields.hosts,
      selector: {
        default: ['node', 'node'],
      },
    },
    image: {
      ...D2C_ServiceApp.fields.image,
      default: 'd2cio/php',
    },
    ports: {
      ...D2C_ServiceApp.fields.ports,
      default: [
        {protocol: 'TCP', value: 9000},
      ],
    },
    remoteAccess: {
      ...D2C_ServiceApp.fields.remoteAccess,
      hidden: true,
    },
    source: {
      ...D2C_ServiceApp.fields.source,
      example: 'https://github.com/d2cio/php-hello-world',
    },
    version: {
      ...D2C_ServiceApp.fields.version,
      default: '7.3',
      enum: ['7.1', '7.2', '7.3'],
    },
    volumes: {
      ...D2C_ServiceApp.fields.volumes,
      demo: [
        {src: '/ebs/containers/$serviceName/sources', dst: '/var/www/$serviceName', sync: false},
      ],
    },
  }
}

export default D2C_ServicePHP
